module.exports = __webpack_public_path__ + "img/generic.850b2ac4.jpg";